import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
  SleepTestId,
  sleepTestTranslated,
} from 'src/app/modules/registration/data/sleep-test.type';
import {
  startTherapyGroupIds,
  StartTherapyGroupId,
  startTherapyGroups,
  StartTherapyGroupName,
} from 'src/app/modules/registration/data/start-therapy-group.type';
// implementation postponed due to MWEB-714
// import { BaselineSleepinessValues } from 'src/graphql/types/api.types';

@Component({
  selector: 'mpp-add-health-profile',
  templateUrl: './add-health-profile.component.html',
  styleUrls: ['./add-health-profile.component.scss'],
  standalone: false,
})
export class AddHealthProfileComponent {
  @Input() healthProfileForm: UntypedFormGroup;
  @Input() formSubmitted: boolean = false;

  /**
   * Checks if sleep test type field should show required error
   * Matches the validation pattern used by other required fields in registration form
   */
  public isSleepTestTypeRequired(): boolean {
    const control = this.healthProfileForm.get('sleepTestType');
    return (
      (control.errors?.required && (control.touched || control.dirty)) ||
      (control.invalid && this.formSubmitted)
    );
  }

  /**
   * Checks if start therapy group field should show required error
   * Matches the validation pattern used by other required fields in registration form
   */
  public isStartTherapyGroupRequired(): boolean {
    const control = this.healthProfileForm.get('startTherapyGroup');
    return (
      (control.errors?.required && (control.touched || control.dirty)) ||
      (control.invalid && this.formSubmitted)
    );
  }

  // implementation postponed due to MWEB-714
  // public baselineSleepinessValues = BaselineSleepinessValues;
  // public baselineSleepinessList: BaselineSleepinessValues[] = [
  //   BaselineSleepinessValues.extremely,
  //   BaselineSleepinessValues.very,
  //   BaselineSleepinessValues.moderately,
  //   BaselineSleepinessValues.slightly,
  //   BaselineSleepinessValues.notAtAll,
  // ];

  // get sleep test types for dropdown (home, lab, both, notKnown)
  public getSleepTestTypeIds(): readonly SleepTestId[] {
    return ['home', 'lab', 'both', 'notKnown'] as const;
  }

  public getSleepTestTypeTranslationId(sleepTestId: SleepTestId): string {
    return sleepTestTranslated[sleepTestId];
  }

  public getStartTherapyGroupIds(): readonly string[] {
    return startTherapyGroupIds;
  }

  public getStartTherapyGroupName(startTherapyGroupId: StartTherapyGroupId): StartTherapyGroupName {
    return startTherapyGroups[startTherapyGroupId];
  }

  public getAHIeventsErrorKeys(): string[] {
    const { errors } = this.healthProfileForm.get('AHIevents');
    if (!errors) return [];
    if (errors.min || errors.max) {
      return ['ERRORS.InvalidAHIBaseline'];
    }
    if (errors.firstZeroRestricted) {
      return ['ERRORS.InvalidAHIBaseline', 'ERRORS.AHIOneDecimal'];
    }
    if (errors.pattern) {
      return ['ERRORS.AHIOneDecimal'];
    }
    return [];
  }
}
